import moment from 'moment';
const KEY = "tl-tags";

export default class TagsStorage {
    saveTags (tags){
        if (tags && Object.entries(tags).length > 0) {
            window.localStorage.setItem(KEY, JSON.stringify({lastRefreshed: Date.now(), tags: tags }));
        }
    }

    loadTags() {
        return JSON.parse(window.localStorage.getItem(KEY));
    }

    areTagsExpired() {
        const tags = this.loadTags();
        if (!tags) {
            return true;
        }

        const now = moment(new Date());
        const lastRefreshed = moment(tags.lastRefreshed);
        const expired = (now.diff(lastRefreshed, 'hours') > 1);

        return expired;
    }

    clearTags() {
        window.localStorage.removeItem(KEY);
    }
}
